import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/pickups',
    name: 'pickups',
    component: () => import('@/views/pages/pickups/PickupList.vue'),
    meta: {
      pageTitle: 'Pickup',
      breadcrumb: {
        label: 'Pickup'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER],
      verticalMenu: {
        title: 'Pickup',
        icon: 'ArchiveIcon'
      }
    }
  },
  {
    path: '/pickups/:id',
    name: 'pickup_detail',
    component: () => import('@/views/pages/pickups/PickupDetail.vue'),
    meta: {
      pageTitle: 'Pickup Detail',
      breadcrumb: {
        label: 'Pickup Detail',
        parent: 'pickups'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]
    }
  }
];
